<template>
  <div class="integral-canvas">
    <!-- 无积分兑换卡片 -->
    <div v-if="cardList.length == 0" class="no-cards"></div>

    <!-- 积分兑换卡片 -->
    <div v-if="cardList.length != 0">
      <div
        class="card-canvas"
        v-for="(item, index) in cardList"
        :key="index"
        :class="{'card-has-info':item.id}"
      >
        <!-- 可兑换的卡片 -->
        <div v-if="item.id" class="card-info">
          <!-- 兑换现金 -->
          <div class="info-money">
            <span class="m-lab m-symbol"></span>
            <span
              class="m-lab m-num"
              :class="'m-'+n"
              v-for="(n, v) in item.money.toString().replace('.','p').split('')"
              :key="v"
            ></span>
            <span class="lab">现金</span>
          </div>
          <!-- 兑换条件 -->
          <div class="info-condition">提现条件: {{item.condition}}</div>
          <!-- 兑换按钮 -->
          <div class="info-btn" @click="openConfirmWin(item)"></div>
          <!-- 兑换积分 -->
          <div class="info-score">{{item.score}}积分兑换</div>
        </div>
      </div>
    </div>

    <!-- 当前积分 -->
    <div class="current-score">
      <span class="left-arrow" :class="{'left-arrow-dis':this.curPage == 1}" @click="leftHandler()"></span>
      <span class="score-lab"></span>
      <span
        class="score-num"
        :class="'s-'+n"
        v-for="(n, v) in currentPoint.toString().split('')"
        :key="v"
      ></span>
      <span
        class="right-arrow"
        :class="{'right-arrow-dis':this.curPage == this.totalPage}"
        @click="rightHandler()"
      ></span>
    </div>

    <!-- 兑换确认框 -->
    <el-dialog title="提示" :visible.sync="confirmWiVisible" :show-close="false">
      <div class="transfer-canvas">
        <div class="score-lab">{{transferScore}}积分</div>
        <div class="transfer-icon"></div>
        <div class="money-lab">¥{{transferMoney}}现金</div>
      </div>

      <div class="transfer-tip">积分兑换现金，确认兑换吗？</div>

      <div class="transfer-btns">
        <div class="btn-cancel" @click="confirmWiVisible = false">取消</div>
        <div class="btn-confirm" @click="confirmeHandler()">确定</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "integral-comp",
  props: {
    cardList: Array,
    currentPoint: Number,
    curPage: Number,
    totalPage: Number
  },
  data() {
    return {
      confirmWiVisible: false,
      transferScore: 0,
      transferMoney: 0,
      transferId: ""
    };
  },
  methods: {
    // 打开兑换确认框
    openConfirmWin(card) {
      if (card.status == 0) {
        return;
      }
      this.confirmWiVisible = true;
      this.transferScore = card.score;
      this.transferMoney = card.money;
      this.transferId = card.id;
    },
    // 确认操作
    confirmeHandler() {
      this.confirmWiVisible = false;
      this.$emit("exchangePoint", this.transferId);
    },
    // 上頁
    leftHandler() {
      if (this.curPage == 1) {
        return;
      }
      this.$emit("prePage");
    },
    // 下頁
    rightHandler() {
      if (this.curPage == this.totalPage) {
        return;
      }
      this.$emit("nextPage");
    }
  }
};
</script>

<style lang="scss">
.integral-canvas {
  width: 100%;
  height: 100%;
  padding: 0 12px;

  .no-cards {
    position: absolute;
    width: 1114px;
    height: 332px;
    top: 20px;
    left: 20px;
    background: url("./img/no-cards.png") no-repeat center center;
  }

  // 积分兑换卡片
  .card-canvas {
    float: left;
    width: 188px;
    height: 350px;
    background: url("./img/card-nothing.png") no-repeat center 0px;
  }

  .card-has-info {
    background: url("./img/card-info.png") no-repeat center 0px;
  }

  // 可兑换的卡片
  .card-info {
    position: relative;
    // 兑换现金
    .info-money {
      position: absolute;
      width: 168px;
      height: 27px;
      top: 158px;
      left: 10px;
      text-align: center;

      .m-lab {
        display: inline-block;
        width: 20px;
        height: 27px;
        margin-right: 2px;
      }

      .m-symbol {
        background: url("./img/money-lab.png") no-repeat center -480px;
      }
      .m-0 {
        width: 16px;
        background: url("./img/money-lab.png") no-repeat -10px -10px;
      }
      .m-1 {
        width: 12px;
        background: url("./img/money-lab.png") no-repeat -10px -57px;
      }
      .m-2 {
        width: 16px;
        background: url("./img/money-lab.png") no-repeat -10px -104px;
      }
      .m-3 {
        width: 17px;
        background: url("./img/money-lab.png") no-repeat -10px -151px;
      }
      .m-4 {
        width: 18px;
        background: url("./img/money-lab.png") no-repeat -10px -198px;
      }
      .m-5 {
        width: 16px;
        background: url("./img/money-lab.png") no-repeat -10px -245px;
      }
      .m-6 {
        width: 17px;
        background: url("./img/money-lab.png") no-repeat -10px -292px;
      }
      .m-7 {
        width: 17px;
        background: url("./img/money-lab.png") no-repeat -10px -339px;
      }
      .m-8 {
        width: 18px;
        background: url("./img/money-lab.png") no-repeat -10px -386px;
      }
      .m-9 {
        width: 16px;
        background: url("./img/money-lab.png") no-repeat -10px -433px;
      }

      .m-p {
        width: 16px;
        background: url("./img/point.png") no-repeat center center;
        background-size: contain;
      }

      .lab {
        display: inline-block;
        font-family: "MicrosoftYaHei";
        font-size: 12px;
        color: #621fcc;
        opacity: 0.7;
        font-weight: normal;
      }
    }
    // 兑换条件
    .info-condition {
      position: absolute;
      width: 168px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      top: 195px;
      left: 10px;
      font-family: "MicrosoftYaHei";
      font-size: 12px;
      color: #b47a00;
      font-weight: bold;
    }
    // 兑换按钮
    .info-btn {
      position: absolute;
      width: 120px;
      height: 34px;
      top: 262px;
      left: 34px;
      background: url("./img/score-btn.png") no-repeat center -10px;
      cursor: pointer;
    }
    .info-btn:hover {
      background: url("./img/score-btn.png") no-repeat center -64px;
    }
    // 兑换积分
    .info-score {
      position: absolute;
      width: 168px;
      height: 20px;
      line-height: 20px;
      text-align: center;
      top: 302px;
      left: 10px;
      font-family: "MicrosoftYaHei";
      font-size: 12px;
      color: #b47a00;
      font-weight: normal;
    }
  }

  // 当前积分
  .current-score {
    position: absolute;
    width: 100%;
    height: 44px;
    line-height: 44px;
    text-align: center;
    top: 385px;

    .score-lab {
      display: inline-block;
      width: 113px;
      height: 36px;
      background: url("./img/score-lab.png") no-repeat center center;
      margin-right: 30px;
    }

    .score-num {
      display: inline-block;
      height: 33px;
      margin-right: 5px;
    }

    .s-0 {
      width: 33px;
      background: url("./img/score-num.png") no-repeat -10px -10px;
    }
    .s-1 {
      width: 10px;
      background: url("./img/score-num.png") no-repeat -10px -63px;
    }
    .s-2 {
      width: 30px;
      background: url("./img/score-num.png") no-repeat -10px -116px;
    }
    .s-3 {
      width: 27px;
      background: url("./img/score-num.png") no-repeat -10px -169px;
    }
    .s-4 {
      width: 33px;
      background: url("./img/score-num.png") no-repeat -10px -222px;
    }
    .s-5 {
      width: 29px;
      background: url("./img/score-num.png") no-repeat -10px -275px;
    }
    .s-6 {
      width: 31px;
      background: url("./img/score-num.png") no-repeat -10px -328px;
    }
    .s-7 {
      width: 29px;
      background: url("./img/score-num.png") no-repeat -10px -381px;
    }
    .s-8 {
      width: 31px;
      background: url("./img/score-num.png") no-repeat -10px -434px;
    }
    .s-9 {
      width: 31px;
      background: url("./img/score-num.png") no-repeat -10px -487px;
    }

    .left-arrow {
      display: inline-block;
      width: 44px;
      height: 44px;
      background: url("./img/left-arrow.png") -10px -10px;
      margin-right: 80px;
    }

    .left-arrow:hover {
      background: url("./img//left-arrow.png") -10px -74px;
    }

    .left-arrow-dis,
    .left-arrow-dis:hover {
      background: url("./img//left-arrow.png") -10px -138px;
    }

    .right-arrow {
      display: inline-block;
      width: 44px;
      height: 44px;
      background: url("./img/right-arrow.png") -10px -10px;
      margin-left: 80px;
    }

    .right-arrow:hover {
      background: url("./img//right-arrow.png") -10px -74px;
    }

    .right-arrow-dis,
    .right-arrow-dis:hover {
      background: url("./img//right-arrow.png") -10px -138px;
    }
  }

  // 弹窗信息样式
  .el-dialog__wrapper {
    z-index: 4000 !important;
    background: rgba(0, 0, 0, 0.6);
  }
  .el-dialog {
    width: 380px !important;
    height: 292px;
    background-color: #fff;
    border-radius: 10px;
    margin-top: -146px !important;
    top: 50%;

    .el-dialog__header {
      text-align: center;
    }

    .el-dialog__title {
      text-align: center;
      font-family: "MicrosoftYaHei";
      font-size: 14px;
      color: #150036;
      font-weight: normal;
    }

    .el-dialog__body {
      padding: 0px;
    }

    .transfer-canvas {
      width: 353px;
      height: 54px;
      margin: 30px auto 0px auto;

      .score-lab {
        float: left;
        width: 150px;
        height: 54px;
        line-height: 54px;
        text-align: center;
        color: #a7a1b2;
        font-family: "MicrosoftYaHei";
        font-size: 16px;
        font-weight: normal;
      }

      .transfer-icon {
        float: left;
        width: 53px;
        height: 54px;
        background: url("./img/transfer-icon.png") no-repeat center center;
      }

      .money-lab {
        float: left;
        width: 150px;
        height: 54px;
        line-height: 54px;
        text-align: center;
        color: #a7a1b2;
        font-family: "MicrosoftYaHei";
        font-size: 16px;
        font-weight: normal;
      }
    }

    .transfer-tip {
      width: 100%;
      height: 20px;
      line-height: 20px;
      font-family: "MicrosoftYaHei";
      font-size: 14px;
      font-weight: normal;
      color: #150036;
      text-align: center;
      margin: 30px 0px 35px 0px;
    }

    .transfer-btns {
      width: 100%;
      height: 40px;

      .btn-cancel {
        position: absolute;
        width: 110px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background-color: #fff;
        border-radius: 4px;
        border: solid 1px #2b2b2b;
        color: #2b2b2b;
        left: 40px;
        cursor: pointer;
      }

      .btn-confirm {
        position: absolute;
        width: 110px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        background-image: linear-gradient(90deg, #2b2b2b 0%, #404040 100%),
          linear-gradient(#c8372a, #c8372a);
        background-blend-mode: normal, normal;
        color: #fff;
        border-radius: 4px;
        right: 40px;
        cursor: pointer;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/build08/components/signInActivity/components/integral/integral-comp.vue